import { render, staticRenderFns } from "./PersonalSettingsView.vue?vue&type=template&id=65fc992a&scoped=true&"
import script from "./PersonalSettingsView.vue?vue&type=script&lang=ts&"
export * from "./PersonalSettingsView.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalSettingsView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PersonalSettingsView.vue?vue&type=style&index=1&id=65fc992a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fc992a",
  null
  
)

export default component.exports